import { Navigate, Route, Routes } from 'react-router-dom';
import { useRouteUrl } from '../../hooks/use-route-url';
import NpsSurvey from './NpsSurvey';

const Surveys: React.FC = () => {
  const url = useRouteUrl();

  return (
    <Routes>
      {/*  TODO add custom surveys and implement selection between nps and custom surveys when it will be requested*/}
      <Route index element={<Navigate to={`${url}/nps`} replace />} />
      <Route path="nps/*" element={<NpsSurvey />} />
    </Routes>
  );
};

export default Surveys;
